import { useState, useEffect } from "react";
import Select from "react-select";
import { HospitalServices } from "../services/HospitalServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import AddHospitalIcon from "../assets/AddExtraHospital.svg";
const BilledTo = () => {
  const [hospitalList, setHospitalList] = useState([]);
  const getHospitalList = async () => {
    try {
      const response = await HospitalServices.gethospitals("", 1, 1500);
      setHospitalList(response.data.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    getHospitalList();
  }, []);
  return (
    <div>
      <div className="text-xl font-semibold">Billed To</div>
      <div className="mt-4">Enter Hospital details for Billing.</div>
      <div className="w-full flex items-center gap-6 mt-4">
        <div className="flex-1">
          <Select
            name="hospitalId"
            options={hospitalList}
            getOptionLabel={(options) => {
              return options["name"];
            }}
            getOptionValue={(options) => {
              return options["id"];
            }}
            // onChange={(item) => {
            //   setFieldValue("hospitalId", item.id);
            // }}
            placeholder="Select from saved Hospitals"
          />
        </div>
        <div className="flex-shrink-0 flex items-center gap-2 text-sm text-white font-semibold bg-[#017C57] -tracking-[0.4px] px-5 py-3 rounded-[8px] cursor-pointer">
          <img src={AddHospitalIcon} alt="add-hospital" />
          ADD HOSPITAL
        </div>
      </div>

      <div className="flex items-center w-full mt-10 mb-3">
        <div className="flex-1 h-px bg-[#DEDEDE]" />
        <span className="mx-1 text-sm text-[#191919] whitespace-nowrap">
          Or enter manually
        </span>
        <div className="flex-1 h-px bg-[#DEDEDE]" />
      </div>
      <div className="mb-3">
        <div className="text-[#191919] font-semibold mb-4">Hospital Name</div>
        <input
          type="text"
          placeholder="Enter Hospital name here"
          className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
        />
      </div>

      <div className="mb-3">
        <div className="text-[#191919] font-semibold mb-4">
          Hospital Address
        </div>
        <input
          type="text"
          placeholder="Enter Hospital name here"
          className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
        />
      </div>
      <div className="flex gap-20 items-center">
        <div className="flex-1 mb-3">
          <div className="text-[#191919] font-semibold mb-4">Phone Number</div>
          <input
            type="text"
            placeholder="Enter Hospital name here"
            className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
          />
        </div>
        <div className="flex-1 mb-3">
          <div className="text-[#191919] font-semibold mb-4">Email</div>
          <input
            type="text"
            placeholder="Enter Hospital name here"
            className="w-full border border-solid border-[#E4E4E4] py-[10px] px-3 rounded-[8px]"
          />
        </div>
      </div>
    </div>
  );
};

export default BilledTo;
